import { useSearchParams } from "react-router-dom"
import { findInChildren, TreeRoot } from "library/tree/index.mjs"
import { parentTreeItem } from "routes/schedule/tree/schedules/makeTreeItemsFromGroup"
import { cleanState } from "routes/schedule/components/schedule-breadcrumbs"
import { ShareBreadcrumbItem } from "./share-breadcrumb-item"

// Builds the breadcrumb props for the share-recipient regime browse, fed into PageBreadcrumbContainer
// so the trail renders in the page header (under the title, above Back) like the standard selector.
//
// IMPORTANT: this runs at the page root, so it must NOT use refreshing hooks (useStack / useTreeItem
// with alwaysRefresh) — those re-render the whole page on every tree event and starve the schedule
// list's async filter ("No Schedules"). Instead it walks the already-loaded `tree` purely. The walk
// stops below the TreeRoot ("Maintenance Regimes"), which isn't part of the shared regime and 404s.
export function useShareBreadcrumbProps(tree, regimeId) {
    const [searchParams] = useSearchParams()
    // Tree is undefined during the initial load; bail before walking it.
    if (!tree) return null

    const currentId = searchParams.get("id") ?? regimeId
    const current = findInChildren(tree, (node) => node.id === currentId)[0]

    if (!current) return null

    const ancestors = []
    let scan = current[parentTreeItem]
    while (scan && !scan[TreeRoot]) {
        ancestors.unshift(scan)
        scan = scan[parentTreeItem]
    }

    return {
        parentCrumbs: buildParentCrumbs(ancestors),
        crumb: cleanState(current.label),
    }

    function buildParentCrumbs(nodes) {
        const crumbs = []
        for (const node of nodes) {
            crumbs.push(<ShareBreadcrumbItem key={node.id} id={node.id} label={node.label} />)
        }
        return crumbs
    }
}
